<template>
	<div class="pt-2">
		<CommonFlame :title="title">
      <!-- ここにプレビュー表示 -->
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		CommonFlame,
	},
	data() {
		return {
			title: "材料準備表兼報告書印刷",
			common,
		}
	},

	mounted() {
		this.fetchConstructionInfo()
	},
	methods: {
		fetchConstructionInfo() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/construction_informations/${this.id}`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>